<template>
  <div class="widget-video-youtube embed-container my-5">
    <iframe
      v-if="youtubeId !== undefined"
      :src="'https://www.youtube.com/embed/' + youtubeId"
    />
  </div>
</template>

<script>
export default {
  name: 'Youtube',
  props: {
    /**
     * youtube video id-je
     */
    youtubeId: {
      type: [String, Number],
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">

.widget-video-youtube {
  &.embed-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;

    iframe, object, embed {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
